module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n        professional APP.")]) : _vm._e(), _vm._v(" "), _c('downloadheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadHeaderShow),
      expression: "downLoadHeaderShow"
    }],
    attrs: {
      "id": "headwrap"
    }
  }), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getHomeSubTabList,
      "navSelected": _vm.currentNavTag
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.getNoDataMode) ? _c('nodata', {
    attrs: {
      "whiteMode": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getLoadingShow) ? _c('loading') : _vm._e(), _vm._v(" "), (_vm.subtitChoose == 'Headline' ? true : false) ? _c('carousel', {
    attrs: {
      "carouselImgData": _vm.getCarouselData,
      "firstTit": _vm.firstTit,
      "subtit": _vm.subtitChoose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subtitChoose == 'Headline' && !_vm.isExternalAccess) ? _c('transfer-entrance') : _vm._e(), _vm._v(" "), (!_vm.getNoDataMode && !_vm.getLoadingShow) ? _c('div', {
    staticClass: "listwrap"
  }, [_vm._l((_vm.getCurrentListData), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: ("/news/" + (_vm.getUrlTitle(_vm.subtitChoose)) + "/" + (_vm.getUrlTitle(data.title)) + "/" + (data.id))
        }
      }
    }, [_c('list-item', {
      attrs: {
        "listData": data,
        "firstTit": _vm.firstTit,
        "subtit": _vm.subtitChoose
      }
    })], 1)], 1)
  }), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please use the\n                normal mode to visit our website.")]) : _vm._e(), _vm._v(" "), (!!_vm.getLoadNext) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.getLoadNext) ? _c('div', {
    staticClass: "noMoreDatas"
  }, [_vm._v("\n                No More Data\n            ")]) : _vm._e()], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cb91a88","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppHome.vue
// module id = 602
// module chunks = 5